<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">Edit Tariff</p>
			</div>
		</div>

		<div class="row margin-b50">
			<div class="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 w-full">
				<div class="card formPanel">
					<div class="content">
						<div class="margin-b30">
							<div class="col-md-12">
								<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
									<div>
										<SearchableDropdown
											v-model="tariff.zone_name"
											:options="zoneNames"
											label="Zone Name"
											placeholder="-- Select Zone --"
											:is-searchable="true"
											:multi-select="false"
											search-placeholder="Search zones..."
										/>
									</div>
									<div>
										<div class="formGroup withIcon">
											<label class="textGrey">Time Class:</label>
											<select v-model="tariff.time_class" required>
												<option value="ANY_DAY">Any Day</option>
												<option value="PEAK">Peak</option>
												<option value="OFF_PEAK">Off-Peak</option>
												<option value="WEEKEND">Weekend</option>
											</select>
											<span class="fa-light fa-chevron-down absolute right-3 z-20"></span>
										</div>
									</div>
								</div>

								<div class="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
									<div class="formGroup withIconLeft">
										<label class="textGrey">Min Charge:</label>
										<input
											v-model="tariff.min_chg"
											type="number"
											step="0.000001"
											required
											@blur="tariff.min_chg = tariff.min_chg || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">Initial Charge:</label>
										<input
											v-model="tariff.init_chg"
											type="number"
											step="0.000001"
											required
											@blur="tariff.init_chg = tariff.init_chg || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">First Charge:</label>
										<input
											v-model="tariff.first_chg"
											type="number"
											step="0.000001"
											required
											@blur="tariff.first_chg = tariff.first_chg || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">First Time (seconds):</label>
										<input
											v-model="tariff.first_time"
											class="pl-8"
											type="number"
											step="1"
											required
											@blur="tariff.first_time = tariff.first_time || 0"
										/>
										<span
											class="fa-light fa-clock absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">Sub Charge:</label>
										<input
											v-model="tariff.sub_chg"
											type="number"
											step="0.000001"
											required
											@blur="tariff.sub_chg = tariff.sub_chg || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">Sub Time (seconds):</label>
										<input
											v-model="tariff.sub_time"
											class="pl-8"
											type="number"
											step="1"
											required
											@blur="tariff.sub_time = tariff.sub_time || 0"
										/>
										<span
											class="fa-light fa-clock absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">MAL:</label>
										<input
											v-model="tariff.mal"
											type="number"
											step="0.000001"
											required
											@blur="tariff.mal = tariff.mal || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>

									<div class="formGroup withIconLeft">
										<label class="textGrey">PAL:</label>
										<input
											v-model="tariff.pal"
											type="number"
											step="0.000001"
											required
											@blur="tariff.pal = tariff.pal || 0"
										/>
										<span
											class="fa-light fa-sterling-sign absolute z-[3] text-gray-500 dark:text-gray-400"
										></span>
									</div>
								</div>

								<p v-if="tariff.updatedAt" class="mt-4 font-light opacity-50 dark:text-gray-300">
									Last updated at: {{ $global.dateWordFormat(tariff.updatedAt) }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li>
						<button :disabled="!tariff.zone_name" class="jmiBtn btnLg green" @click="save()">
							Confirm
						</button>
					</li>
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import SearchableDropdown from './common/SearchableDropdown.vue'

export default {
	components: {
		SearchableDropdown
	},
	inject: ['user', 'userRoles'],
	props: ['tariffEntry', 'showTariffEdit', 'zoneNames'],

	data() {
		return {
			tariff: {
				zone_name: this.tariffEntry?.zone_name || '',
				time_class: this.tariffEntry?.time_class || '',
				min_chg: this.tariffEntry?.min_chg || 0,
				init_chg: this.tariffEntry?.init_chg || 0,
				first_chg: this.tariffEntry?.first_chg || 0,
				first_time: this.tariffEntry?.first_time || 0,
				sub_chg: this.tariffEntry?.sub_chg || 0,
				sub_time: this.tariffEntry?.sub_time || 0,
				mal: this.tariffEntry?.mal || 0,
				pal: this.tariffEntry?.pal || 0,
				id: this.tariffEntry?.id,
				updatedAt: this.tariffEntry?.updatedAt
			}
		}
	},

	mounted() {
		document.addEventListener('keyup', this.onKeyUp)
	},
	beforeUnmount() {
		document.removeEventListener('keyup', this.onKeyUp)
	},

	methods: {
		sanitizeTariffData(data) {
			return {
				id: data.id,
				zone_name: data.zone_name || '',
				time_class: data.time_class || '',
				min_chg: parseFloat(data.min_chg)?.toFixed(6) || 0,
				init_chg: parseFloat(data.init_chg)?.toFixed(6) || 0,
				first_chg: parseFloat(data.first_chg)?.toFixed(6) || 0,
				first_time: parseFloat(data.first_time)?.toFixed(0) || 0,
				sub_chg: parseFloat(data.sub_chg)?.toFixed(6) || 0,
				sub_time: parseFloat(data.sub_time)?.toFixed(0) || 0,
				mal: parseFloat(data.mal)?.toFixed(6) || 0,
				pal: parseFloat(data.pal)?.toFixed(6) || 0
			}
		},
		save() {
			this.$emit('save', this.sanitizeTariffData(this.tariff))
		},
		close() {
			this.$emit('close')
		},
		onKeyUp(event) {
			if (event.key == 'Escape') this.$emit('close')
		}
	}
}
</script>
